import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import Styles from "../../../../../Slices/Mof/Styles.json";
import Imagelist from "./ImageList";
import ApiSetting from "../../../../../../Settings/ApiSettings.json";
import './ExportPdf.css'
import gsap from "gsap";
import axios from "axios";
import swal from "sweetalert";

function ExportPdf({getCurrentReportDataAfterUpdate,object}) {
     const [loading,setLoading]=useState(false)
    const downloadFIle=async()=>{
      let data=null;
      setLoading(true)
    try{
        data=await  axios({
            url: ApiSetting.apiUrl+'/downloadFiles', //your url
            method: 'post',
            // responseType: 'text', // important
            headers:{
                'Content-Type': 'application/json', 
                'Accept': 'application/json', 
            },
            data:object
        })
        if(data){
            if(data.data.status==200)
              window.open(data?.data?.data)

        }
        setLoading(false)
    }catch(error){
        setLoading(false)
        if (error.response) {
            // Request made and server responded
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            alert('d1')
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
            alert('d2')
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            alert('d3')
          }
    }
}
    
    


    return (
        <div className="ExportPdf">
            {/*###==>images upload ...  */}
            <h4
                style={{
                    marginRight: "10px",
                    color: "#5f7b8a",
                }}
            >
                تحميل البيانات{" "}
            </h4>
            <div style={{width:'200px',margin:"20px 0"}}>
                <Button variant="contained" onClick={downloadFIle}>
                    {
                        !loading?"تحميل المستمسكات":
                        <div className="spinner-border " role="status">
                             <span className="visually-hidden">Loading...</span>
                         </div>
                    }
                    </Button>

            </div>
           
        </div>
    )
}

export default ExportPdf